import React from 'react'
import { useThemeable, Headline, Media, Section, HStack, VStack, Title2, Body, Space, Title3, Caption1, Container, Icon, Subhead, Title1, Divider } from '@themeable/react'

export const PostpartumServices = () => {

  const { textStyle } = useThemeable()

  const paragraphs = [
    'For all packages, we will start with a prenatal visit in your home to meet each other in person, discuss how I can be most helpful, and answer any questions that you have. If you already had your baby, there will be a free 30 minutes added on to the beginning of our first day together!',
    'Current offerings include 3 different support packages: 4 weeks, 6 weeks, and 8 weeks. My rate is $60/hour for daytime postpartum services, and shifts are typically 4-6 hours. I can also customize to your specific needs. Serving you with the right amount of hours/weeks is important to me!'
  ]

  const services = [
    {
      name: '4 Week Package',
      description: '8-16 visits completed within 6 weeks postpartum, total cost varies based upon hours purchased.'
    },
    {
      name: '6 Week Package',
      description: '12-24 visits completed within 8 weeks postpartum, total cost varies based upon hours purchased.',
    },
    {
      name: '8 Week Package',
      description: '16-32 visits completed within 10 weeks postpartum, total cost varies based upon hours purchased.'
    }
  ]

  const bullets = [
    "Education on newborn care such as bath time, baby sleep, diaper changes, how to respond to baby’s cues and cries, etc.",
    "Create a routine for you and your baby to get maximized sleep",
    "Care for your baby while you sleep, read a book, eat a freshly prepared meal, have alone time, enjoy time with your spouse, or all of the above!",
    "Education on breastfeeding, pumping, bottle feeding, formula feeding",
    "Help baby latch and go through breastfeeding positions",
    "Troubleshoot feeding issues",
    "Organizing your nursery",
    "Sibling care",
    "Meal planning and prep",
    "Household chores: washing/folding laundry, vacuuming, dishes, washing bottles/pump parts",
    "Running errands-grocery store, order pickup from your favorite take out, nordstrom return, etc here I come!",
    "Holding space for you to talk about your birth/postpartum experience",
    "Education on vaccines and health concerns such as reflux, slow weight gain, etc",
    "Tools and resources for postpartum depression or anxiety",
  ]

  return (<>

    <Section>
      <VStack style={{ position: 'absolute', transform: 'translate(24px, -50%) rotate(-15deg)', right: '80px' }}>
        <Icon
          name='Heart'
          size='300px'
          color='accent'
        />
      </VStack>
      <Title1 color='primary'>Postpartum Doula Services</Title1>
      {paragraphs.map((p) => (<Body> {p} </Body>))}
      <HStack>
        {services.map((item, index) => (
          <Container variant='fill'>
            <VStack key={index} group>
              <Headline color='primary'>{item.name}</Headline>
              <Subhead key={index}>{item.description}</Subhead>
            </VStack>
          </Container>
        ))}
      </HStack>

      <Divider />

      <Title3 color='primary'>Postpartum care is all about supporting you! Here are some ideas of how I can come alongside you:</Title3>
      <VStack group>
        {bullets.map((bullet) => (
          <>
            <HStack>
              <VStack width='hug' align='middle' style={{
                height: textStyle.bodyLineHeight,
              }}>
                <Icon size='16px' color='primary' name='Bullet' />
              </VStack>
              <Body>{bullet}</Body>
            </HStack>
            <Space.Content />
            <Space.Content />
          </>
        ))}
      </VStack>
    </Section>

  </>)
}

